import styled from "styled-components";
import Logo from '../../assets/logo.svg';

const S = {
    Wrapper: styled.footer`
        display: flex;
        flex-direction: column;
        z-index: 9;
        background-color: #EAEAF6;
        padding: 60px 40px 0px 40px; 
        margin-top: 0px;
        box-sizing: border-box;
        width: 100%;

        @media (max-width: 1024px) {
            padding: 40px 20px 0px 20px;
        }

        @media (max-width: 648px) {
            padding: 24px 14px 0px 14px;
        }

        .copyright {
            opacity: 0.8;
            display: flex;
            padding: 20px 0px;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
            color: #677294;
            font-size: 13px;
            margin: 0px 40px;

            @media (max-width: 768px) {
                flex-direction: column;
                margin: 0px 10px;
                gap: 10px;
                text-align: center;
            }

            a {
                text-decoration: none;
                color: #1e293b;
                transition: color 0.3s ease;
                
                &:hover {
                    color: #00A9C4;
                }
            }
        }

        p {
            color: #475569;
            width: 100%;
        }
    `,
    Ust: styled.div`
        padding: 0px 40px 40px 40px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 40px;
        margin-bottom: 20px;
        height: auto;
        position: relative;
        font-size: 14px;

        @media (max-width: 900px) {
            grid-template-columns: 1fr;
            padding: 0px 10px 20px 10px;
            grid-gap: 24px;
        }

        &::after {
            content: "";
            background-size: cover;
            background-image: url(${Logo});
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: -1;  
            opacity: 0.04;
        }

        h2 {
            color: #1e293b;
            font-size: 1.3em;
            margin-top: 0;
        }

        iframe {
            border: none;
            width: 100%;
            height: 180px;
            border-radius: 12px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.06);
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
            color: #64748b;
            li {
                padding-top: 10px;
                line-height: 1.6;
            }
        }

        p {
            color: #64748b;
            line-height: 1.6;
        }

        .socialMedia {
            display: flex;
            flex-direction: row;
            gap: 16px;
            margin-top: 15px;

            a {
                img {
                    width: 24px;
                    height: 24px;
                    transition: transform 0.2s ease, filter 0.2s ease;
                }
                &:hover img {
                    transform: translateY(-2px);
                    filter: brightness(60%);
                }
            }
        }
    `,
    Img: styled.img`
        width: 100%;
        object-fit: cover;
        position: absolute;
        z-index: -10;
    `,
    Logo: styled.img`
        width: 220px;
        max-width: 100%;
        height: auto;
        grid-area: logo;
        margin-bottom: 15px;

        @media (max-width: 648px) {
            width: 160px;
        }  
    `,
    Memnun: styled.div`
        position: relative;
        top: -40px;
        display: flex;
        justify-content: center;
        border-radius: 16px;
        padding: 0 16px;
        box-sizing: border-box;
        width: 100%;
       
        .main {
            background-color: #00A9C4;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            max-width: 780px;
            padding: 24px 36px;
            border-radius: 18px;
            box-shadow: 0 12px 35px rgba(0, 169, 196, 0.3);
            transition: all 0.3s ease;
            box-sizing: border-box;

            @media (max-width: 768px) {
                flex-direction: column;
                padding: 20px 16px;
                text-align: center;
                gap: 16px;
            }  

            a {
                background: #1e293b;
                border-radius: 25px;
                padding: 14px 28px;
                text-decoration: none;
                color: white;
                font-weight: 700;
                font-size: 14px;
                white-space: nowrap;
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);

                @media (max-width: 768px) {
                    width: 100%;
                    max-width: 260px;
                    box-sizing: border-box;
                    text-align: center;
                }

                &:hover {
                    background-color: white;
                    color: #00A9C4;
                    transform: translateY(-2px);
                }
            }
        }
    `,
    Tex: styled.div`
        flex: 1;
        padding-right: 20px;

        @media (max-width: 768px) {
            padding-right: 0;
            width: 100%;
        }  

        h3 {
            color: white;
            padding: 0px;
            margin: 0px 0px 6px 0px;
            font-weight: 700;
            font-size: 1.25em;
        }

        p {
            font-size: 13px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            margin: 0;
            line-height: 1.5;
        }
    `,
    Email: styled.div`
        height: 40px;
        background: white;
        border-radius: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px;

        input {
            border: 0px;
            outline: none;
            width: 200px;
            padding-left: 20px;
            box-sizing: border-box;

            @media (max-width: 648px) {
                width: 100%;
            } 
        }

        button {
            background-color: #A2432B;
            border: 0px;
            border-radius: 40px;
            color: white;
            padding: 10px 15px;
            transition: 200ms;

            &:hover {
                transition: 200ms;
                background-color: black;
            }
        }
    `
};

export default S;